import { render, staticRenderFns } from "./GroupDrugSearch.vue?vue&type=template&id=020ee6aa&lang=pug"
import script from "./GroupDrugSearch.vue?vue&type=script&lang=js"
export * from "./GroupDrugSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {InlineAccountModal: require('/home/docker/code/frontend/components/InlineAccountModal.vue').default,GroupPlanSelectFromCopays: require('/home/docker/code/frontend/components/GroupPlanSelectFromCopays.vue').default,Location: require('/home/docker/code/frontend/components/Location.vue').default,FormDrugs: require('/home/docker/code/frontend/components/form/Drugs.vue').default})
